import ctl from '@netlify/classnames-template-literals';

export const classes = {
  container: ctl(`
    border-[1px]
    border-azureish-white
    shadow-cetacean-blue
    overflow-hidden
    rounded-md  
    max-w-[750px]
  `),
  titleContainer: ctl(`
    flex
    items-center
    justify-between
    border-b-[1px] 
    offset-base
    bg-ghost-white 
    border-azureish-white 
    font-[600]
  `),
  form: 'p-4 bg-white',
  title: 'text-waterspout',
  editIcon: 'text-waterspout cursor-pointer',
  fieldContainer: 'space-y-2',
  btnContainer: 'flex justify-end gap-2 mt-4',
  field: 'flex flex-wrap',
  firstCol: ctl(`
    w-[30%] 
    px-2 
    mb-[5px] 
    text-light-slate-gray
    text-[15px]
  `),
  secondCol: ctl(`
    w-[70%] 
    px-2 
    text-[15px]
  `),
  dl: `flex flex-wrap items-center`,
  cancelBtn: {
    container: 'bg-inherit',
    text: 'text-waterspout',
  },
  saveBtn: 'green-button',
  edit: {
    input: {
      wrapper: 'bg-white',
    },
    select: {
      valueContainer: 'bg-white',
      indicatorsContainer: 'bg-white',
      dropdownIndicator: 'bg-white',
      menuList: 'bg-white',
    },
  },
  phoneInput: 'text-[15px] cursor-text inline-block',
};
